import "../../assets/css/order-confirmation-message.css";
import { PhraseKey, Say } from "../../languages";

type OrderConfirmationMessageProps = {
  messagePhraseKey: PhraseKey;
};

export function OrderConfirmationMessage({ messagePhraseKey }: OrderConfirmationMessageProps) {
  return (
    <div className="order-confirmation-message__wrapper">
      <strong>
        <Say phrase={messagePhraseKey} />
      </strong>
    </div>
  );
}

export default OrderConfirmationMessage;
